<!-- @format -->

<ng-container *transloco="let t">
  <div class="sis-plan-structure-education">
    <div class="sis-plan-structure-education__header">
      <div class="row">
        <div class="col-12 d-flex align-items-center justify-content-between">
          <h2 [attr.id]="educationStateObject?.elementId" data-cy="plan-structure-education-name"
            >{{ education?.name | localizedString }}
            <sis-plan-structure-module-state-badges [documentState]="education.documentState"> </sis-plan-structure-module-state-badges>
          </h2>
          <fudis-icon-button
            class="sis-mr-xs"
            [ariaLabel]="t('SIS_COMPONENTS.PLAN.ARIA.OPEN_PLAN_EDIT_MODAL')"
            [size]="'small'"
            [icon]="'edit'"
            (handleClick)="openModule()"
            [variant]="'tertiary'" />
        </div>
      </div>
      <div class="row sis-plan-structure-education__header__additional-info">
        <div class="d-flex flex-wrap">
          @if (education?.code) {
            <p class="sis-mb-zero">{{ education?.code }}</p>
            <p class="sis-ml-xs sis-mr-xxs">|</p>
          }
          <sis-plan-structure-module-selection-state [stateObject]="planStateObject.education"> </sis-plan-structure-module-selection-state>
        </div>
        <hr class="sis-hr sis-mb-zero sis-mt-xs" />
      </div>
    </div>
    <sis-plan-structure-module-content
      [moduleOrEducation]="education"
      [planValidationResult]="planValidationResult"
      [planData]="planData"
      [planStateObject]="planStateObject"
      [moduleOrEducationStateObject]="planStateObject?.education"
      [headingLevel]="headingLevel + 1">
    </sis-plan-structure-module-content>
  </div>
</ng-container>
